import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { IBranchMastDropdown, IClientCategoriesDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { JobType, Term, Priority, InterviewProcess, ServedStatus, Status, client_Type } from "../../models/FDropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../models/Login";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import { Interview_Process, Job_Type, Req_Priority, Req_Term } from "../../models/RequirementMast";

export interface IReqFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    client?: string | null,
    end_Client?: string | null,
    contact_Person?: string | null,
    contact_Person_Email?: string | null,
    req_ID?: number | null | string,
    req_Hold_UnHoldStatus?: boolean | null,
    req_Priority?: Req_Priority | null,
    served_status?: string | null,
    reqType?: number | null,
    req_Category?: number | null,
    job_Type?: Job_Type | null,
    req_Term?: Req_Term | null,
    req_InterviewProcess?: Interview_Process | null,
    req_PostedBySalesManager?: number | null,
    req_SubmittedByRecruiter?: number | null,
    company?: number | null,
    branch?: number[] | null,
    team?: number | null,
    req_Sub_Category?: number | null,
    special_Constraint?: string | null,
}
export const EmptyFilter: IReqFilter = {
    fromDate: new Date,
    toDate: new Date,
    client: "",
    end_Client: "",
    contact_Person: "",
    contact_Person_Email: "",
    req_ID: "",
    req_Hold_UnHoldStatus: null,
    req_Priority: null,
    served_status: null,
    reqType: null,
    req_Category: null,
    job_Type: null,
    req_Term: null,
    req_InterviewProcess: null,
    req_PostedBySalesManager: null,
    req_SubmittedByRecruiter: null,
    company: null,
    branch: null,
    team: null,
    req_Sub_Category: null,
    special_Constraint: ""
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    client: yup.string().nullable(),
    end_Client: yup.string().nullable(),
    contact_Person: yup.string().nullable(),
    contact_Person_Email: yup.string().nullable(),
    req_ID: yup.string().nullable(),
    req_Hold_UnHoldStatus: yup.boolean().nullable(),
    req_Priority: yup.number().nullable(),
    served_status: yup.string().nullable(),
    reqType: yup.number().nullable(),
    req_Category: yup.number().nullable(),
    job_Type: yup.number().nullable(),
    req_Term: yup.number().nullable(),
    req_InterviewProcess: yup.number().nullable(),
    req_PostedBySalesManager: yup.number().nullable(),
    req_SubmittedByRecruiter: yup.number().nullable(),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    team: yup.number().nullable(),
    req_Sub_Category: yup.number().nullable(),
    special_Constraint: yup.string().nullable(),
});

interface Iprops {
    // open: boolean,
    // hideDialog: () => void,
    // toast: any,
    reqFilter: IReqFilter,
    setReqFilter: (reqFilter: IReqFilter) => void,
    ft: number /* 1-Recruiter All, 2-Recruiter My, 3-Sales My, 4-Sales All */
}

export const Filter = (props: Iprops) => {
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [clientCategories, setClientCategories] = useState<Array<IClientCategoriesDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [subskillCategories, setSubSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedTeam, setselectedTeam] = useState<any | null>(null);

    const { control, handleSubmit, reset, watch } = useForm<IReqFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.reqFilter,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });
    // useEffect(() => {
    //     const subscription = watch((value, { name, type }) => {
    //         if (name === "company" && value.company) loadSales(value.company);
    //         else if (name === "salesPersonFrom" && value.company && value.salesPersonFrom) loadTableData(value.salesPersonFrom);
    //     });
    //     return () => subscription.unsubscribe();
    // }, [watch]);

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    const loadSubSkillCategories = async (parent_id: number) => {
        const response = await Fetch("Dropdown/skillsSubCategories", "GET", null, `parent_id=${parent_id}`, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSubSkillCategories(data);
        }
    }

    const loadSales = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerListBranch", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSales(data);
        }
    }

    const loadRecruiters = async (branch: number[] | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerListBranch", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }

    const loadClientCategories = async () => {
        const response = await Fetch("Dropdown/clientCategories", "GET", null, null, null);
        if (response) {
            const data: Array<IClientCategoriesDropdown> = await response.json();
            const emptyData = {
                reqType_ID: 0,
                reqType: "-- SELECT --",
            };
            data.unshift(emptyData);
            setClientCategories(data);
        }
    }

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = loginObj.id === 1346 || (_roles.includes(34)) ? "allBranches" : "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        let endPoint = loginObj.id === 1346 || (_roles.includes(34)) ? "company" : "reqCompanyList";
        // let endPoint = loginObj.id === 1346 ? "company" : "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const loadTeam = async (branch: number[] | null | undefined, company: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/teamsByBranchesRecs", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }

    useEffect(() => {
        loadClientCategories();
        loadSkillCategories();
        loadSales([], 0, 0);
        loadRecruiters([], 0, 0);
        loadCompanies();

        loadBranches();
        loadTeam([], 0);
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0) {
                    loadBranches(value.company);
                    loadSales([], value.company, 0);
                    loadRecruiters([], value.company, 0);
                    loadTeam([], value.company);
                } else {
                    loadBranches();
                    loadTeam([], 0);
                    if (control._formValues.branch != 0) {
                        loadTeam(control._formValues.branch, 0);
                    } else if (control._formValues.branch == 0) {
                        loadTeam([], 0);
                    }

                    if (control._formValues.branch != 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.branch == 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.branch != 0 && control._formValues.team == 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.branch == 0 && control._formValues.team == 0) {
                        loadRecruiters([], 0, 0);
                    }
                }
            }

            if (name === "branch") {
                if (selectedBranch.length > 0) {
                    // loadSales(value.branch, 0, 0);
                    // loadRecruiters(value.branch, 0, 0);
                    // loadTeam(value.branch, 0);
                } else {
                    if (control._formValues.company != 0) {
                        loadTeam([], control._formValues.company);
                    } else if (control._formValues.company == 0) {
                        loadTeam([], 0);
                    }

                    if (control._formValues.company != 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.company == 0 && control._formValues.team != 0) {
                        loadRecruiters([], 0, control._formValues.team);
                    } else if (control._formValues.company != 0 && control._formValues.team == 0) {
                        loadRecruiters([], control._formValues.company, 0);
                    } else if (control._formValues.company == 0 && control._formValues.team == 0) {
                        loadRecruiters([], 0, 0);
                    }
                }
            }

            if (name === "team") {
                if (value.team && value.team != 0) {
                    loadSales([], 0, value.team);
                    loadRecruiters([], 0, value.team);
                } else {
                    if (control._formValues.company != 0 && control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.company == 0 && control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, 0, 0);
                    } else if (control._formValues.company != 0 && control._formValues.branch == 0) {
                        loadRecruiters([], control._formValues.company, 0);
                    } else if (control._formValues.company == 0 && control._formValues.branch == 0) {
                        loadRecruiters([], 0, 0);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        if (control._formValues.company === 0 && control._formValues.branch === 0 && control._formValues.team === 0) {
            // loginObj.id === 1 ? loadSales(0,0,0) : setSales([]);
            loadSales([], 0, 0);
        }
        if (control._formValues.company != 0 && control._formValues.branch != 0 && control._formValues.team === 0) {
            loadSales(control._formValues.branch, 0, 0);
        }
        if (control._formValues.company != 0 && control._formValues.branch === 0 && control._formValues.team != 0) {
            loadSales([], 0, control._formValues.team);
        }
        if (control._formValues.company === 0 && control._formValues.branch != 0 && control._formValues.team != 0) {
            // loadSales(control._formValues.branch,0,0);
            loadSales([], 0, control._formValues.team);
        }
    }, [control._formValues.company, control._formValues.branch, control._formValues.team]);


    useEffect(() => {

        if (skillCategories) {
            const subscription = watch((value, { name, type }) => {
                if (name === "req_Category") {
                    if (value.req_Category != 0 && value.req_Category != null) {
                        loadSubSkillCategories(value.req_Category);
                    }
                }
            });
            return () => subscription.unsubscribe();
        }
    }, [watch, skillCategories]);
    //  useEffect(() => {
    //         if (selectedBranch.length > 0) {
    //             console.log("Selected Branches:", selectedBranch);
    //             loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch
    //            loadRecruiters(selectedBranch, 0, 0); // Pass the entire array
    //         }

    //     }, [selectedBranch]);


    const searchToDB = async (body: IReqFilter) => {
        // onHide();
        let filterData: any = body;
        if (selectedBranch.length > 0) {
            body.branch = selectedBranch;
        }
        if (selectedTeam != null) {
            body.team = selectedTeam;
        }
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setReqFilter(body);
        // console.log(body);
    }

    function onSubmit(data: IReqFilter) {
        searchToDB(data);
    }


    const special_Constraints = [
        { name: '--Select--' },
        { name: 'PV W2' },
        { name: 'OUR W2' },
        { name: 'Active Security Clearance' },
        { name: 'No Constraints' },
    ]
    useEffect(() => {
        if (selectedBranch.length > 0) {
            console.log("Selected Branches:", selectedBranch);
            loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch
            loadRecruiters(selectedBranch, 0, 0); // Pass the entire array
            loadSales(selectedBranch, 0, 0);

        }

    }, [selectedBranch]);

    useEffect(() => {
        if (selectedTeam != null) {
            // loadRecruiters(selectedBranch, 0, 0); // Pass the entire array
            loadSales([], 0, selectedTeam);
        }
    }, [selectedTeam]);

    const Clear = () => {
        reset(EmptyFilter);
        loadSales([], 0, 0);
        loadRecruiters([], 0, 0);
        loadBranches();
        loadTeam([], 0);
        setSelectedBranch([]);
        setselectedTeam(null);
        // setSales([]);
        // setTeam([]);
    }

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header={props.ft === 1 || props.ft === 4 ? "Search All Requirement" : "Search My Requirement"} modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
            <JVInput column={6} label="Req ID" type="number" control={control} name="req_ID" />
            <JVInput column={6} label="Client" control={control} name="client" />
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVInput column={6} label="End Client" control={control} name="end_Client" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVInput column={6} label="Contact Person" control={control} name="contact_Person" />}

            {/* 1-Recruiter All
                    2-Recruiter My
                    3-Sales My
                4-Sales All */}

            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVInput column={6} label="Contact Person Email" control={control} name="contact_Person_Email" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Status" control={control} name="req_Hold_UnHoldStatus" options={Status} optionLabel="name" optionValue="value" placeholder="Select Status" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Priority" control={control} name="req_Priority" options={Priority} optionLabel="name" optionValue="id" placeholder="Select Priority" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Served" control={control} name="served_status" options={ServedStatus} optionLabel="name" optionValue="name" placeholder="Select Served Status" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Client Category" control={control} name="reqType" options={clientCategories} optionLabel="reqType" optionValue="reqType_ID" placeholder="Select Client Type" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3 || props.ft === 2) && <JVDropdown column={6} label="Client Type" control={control} name="client_Type" options={client_Type} optionLabel="clientTypeName" optionValue="id" placeholder="Select Client Type" />}

            {(props.ft === 4 || props.ft === 1 || props.ft === 3 || props.ft === 2) && <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />}
            <JVDropdown column={6} label="Sub Category" control={control} name="req_Sub_Category" options={subskillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Sub Category" />
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Job Type" control={control} name="job_Type" options={JobType} optionLabel="name" optionValue="id" placeholder="Select Job Type" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Term" control={control} name="req_Term" options={Term} optionLabel="name" optionValue="id" placeholder="Select Term" />}
            {(props.ft === 4 || props.ft === 1 || props.ft === 3) && <JVDropdown column={6} label="Interview Mode" control={control} name="req_InterviewProcess" options={InterviewProcess} optionLabel="name" optionValue="id" placeholder="Select Interview Mode" />}
            {(props.ft === 4 || props.ft === 1) && <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
            {/* {(props.ft === 4 || props.ft === 1) && <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />} */}
            {(props.ft === 4 || props.ft === 1) && <div className="field col-2 md:col-2">
                <p>Sales Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>}

            {/* {(props.ft === 4 || props.ft === 1) && <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />} */}
            {(props.ft === 4 || props.ft === 1) && <div style={{ width: '15%', marginLeft: '10px' }} >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Team</label>

                <Dropdown value={selectedTeam} onChange={(e) => {
                    console.log(e);
                    setselectedTeam(e.value);
                    // loadSm(e.value?.Company,0,0);
                }} options={team} optionLabel="team_Name" placeholder="Select Team" optionValue="team_ID"
                    filter className="w-full" />
            </div>}

            {(props.ft === 4 || props.ft === 1 || props.ft === 2) && (_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20) || _roles.includes(2) || _roles.includes(3) || _roles.includes(4)) && <JVDropdown column={6} label="Sales Manager" control={control} name="req_PostedBySalesManager" options={sales} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" />}
            {(props.ft === 4 || props.ft === 3) && <JVDropdown column={6} label="Recruiter" control={control} name="req_SubmittedByRecruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />}

            <JVDropdown column={6} label="Special Constraint" control={control} name="special_Constraint" options={special_Constraints} optionLabel="name" optionValue="name" placeholder="Select Special Constraint" />

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
            </div>
        </form>

    );
}
